import { Customization, css } from '@eduvision/toolkit';
import image from '../images/BF_Grafik_Header_Katalog.png';

export const ContentListView: Customization['ContentListView'] = {
	imageSrc: image,
};
